import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { Reveal } from "../Reveal";
import { TEAMS, isVideo } from "../../lib/site";

const ORDER = ["feminine", "masculine", "jeunes", "loisir"];

export default function TeamsBento() {
  return (
    <section className="bg-navy py-24 sm:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <SectionHeading number="01" kicker="Nos Équipes" title={<>Un club, pour tous<br />les cyclistes</>} dark />
          <Reveal delay={0.2}>
            <Link
              to="/equipes"
              data-testid="teams-see-all"
              className="group inline-flex items-center gap-3 border border-white/30 text-white font-heading uppercase tracking-wider text-sm px-6 py-3.5 hover:border-rouge hover:text-rouge transition-[border-color,color] duration-300"
            >
              Découvrir nos équipes
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
            </Link>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {ORDER.map((slug, i) => {
            const team = TEAMS[slug];
            return (
              <Reveal key={slug} delay={i * 0.1}>
                <Link
                  to={`/equipes/${slug}`}
                  data-testid={`team-card-${slug}`}
                  className="group relative block overflow-hidden h-[340px] sm:h-[380px]"
                >
                  {isVideo(team.image) ? (
                    <video
                      autoPlay
                      muted
                      loop
                      playsInline
                      style={{ objectPosition: team.position }}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    >
                      <source src={team.image} type="video/mp4" />
                      <source src={team.image.replace(/\.mp4$/i, ".webm")} type="video/webm" />
                    </video>
                  ) : (
                    <img
                      src={team.image}
                      alt={team.name}
                      loading="lazy"
                      style={{ objectPosition: team.position }}
                      className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-7 flex items-end justify-between gap-4">
                    <div>
                      {team.sponsor && (
                        <p className="text-rouge text-xs font-bold uppercase tracking-[0.25em] mb-2">{team.sponsor}</p>
                      )}
                      <h3 className="font-heading uppercase font-semibold tracking-tight text-white text-3xl sm:text-4xl">
                        {team.name}
                      </h3>
                    </div>
                    <span className="shrink-0 flex h-12 w-12 items-center justify-center border border-white/40 text-white transition-[background-color,border-color,transform] duration-300 group-hover:bg-rouge group-hover:border-rouge group-hover:rotate-45">
                      <ArrowRight size={18} />
                    </span>
                  </div>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
